import React, { useState } from 'react';
import {
  Card,
  CardHeader,
  CardContent,
  Typography,
  List,
  ListItem,
  ListItemText,
  Button,
  Divider,
  Box,
} from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import MemberJoinPennantDialog from './MemberJoinPennantDialog';

export default function MemberPennantsCard({ pennants = [], onPennantJoined }) {
  const [openJoinDialog, setOpenJoinDialog] = useState(false);

  const handleOpenDialog = () => setOpenJoinDialog(true);
  const handleCloseDialog = () => setOpenJoinDialog(false);

  return (
    <Card sx={{ margin: 2, padding: 2 }}>
      <CardHeader title="My Pennants" sx={{ pb: 0 }} />
      <CardContent>
        {/* Button below the header */}
        <Box sx={{ mb: 2, textAlign: 'center' }}>
          <Button
            variant="contained"
            onClick={handleOpenDialog}
            sx={{
              textTransform: 'none',
              fontSize: { xs: '0.75rem', sm: '0.875rem' },
              padding: { xs: '4px 8px', sm: '6px 12px' },
            }}
          >
            Join a Pennant
          </Button>
        </Box>
        {pennants.length === 0 ? (
          <Typography
            variant="body1"
            color="textSecondary"
            sx={{ textAlign: 'center', marginY: 2 }}
          >
            No pennants joined yet.
          </Typography>
        ) : (
          <List>
            {pennants.map((pennant, idx) => {
              // Construct display label with pennant.sport in front of pennant.name
              const displayName = `${
                pennant.sport ? `${pennant.sport} ` : ''
              }${pennant.name || ''}`.trim();

              return (
                <React.Fragment key={pennant.pennantId}>
                  <ListItem sx={{ paddingY: 2, alignItems: 'flex-start' }}>
                    <ListItemText
                      primary={
                        <Typography variant="h6" color="primary">
                          {displayName}
                        </Typography>
                      }
                      secondary={
                        <Button
                          component={RouterLink}
                          to={`/dashboard/pennant/${pennant.pennantId}/ladder`}
                          variant="text"
                          color="secondary"
                          size="small"
                          sx={{
                            fontSize: { xs: '0.75rem', sm: '0.875rem' },
                            padding: { xs: '2px 4px', sm: '4px 8px' },
                          }}
                        >
                          View Ladder
                        </Button>
                      }
                    />
                  </ListItem>
                  {idx < pennants.length - 1 && <Divider />}
                </React.Fragment>
              );
            })}
          </List>
        )}
      </CardContent>

      {/* Join Dialog */}
      {openJoinDialog && (
        <MemberJoinPennantDialog
          open={openJoinDialog}
          onClose={handleCloseDialog}
          onPennantJoined={onPennantJoined}
        />
      )}
    </Card>
  );
}
